// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.custom-header {
  position: relative;
  display: inline-block;
  cursor: pointer;
}

.info-icon {
  display: inline-flex;
}

:host {
  background: white;
  border: 1px solid black;
  padding: 5px;
  border-radius: 5px;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/care/custom-header/custom-header.component.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,qBAAA;EACA,eAAA;AACF;;AAEA;EACE,oBAAA;AACF;;AAEA;EACE,iBAAA;EACA,uBAAA;EACA,YAAA;EACA,kBAAA;AACF","sourcesContent":[".custom-header {\n  position: relative;\n  display: inline-block;\n  cursor: pointer;\n}\n\n.info-icon{\n  display: inline-flex;\n}\n\n:host {\n  background: white;\n  border: 1px solid black;\n  padding: 5px;\n  border-radius: 5px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
